import { PartialType } from '@nestjs/swagger';
import { CreatePuntoExpedicionDto } from './create-punto-expedicione.dto';

export class UpdatePuntoExpedicioneDto extends PartialType(CreatePuntoExpedicionDto) {}
